import { Button } from "@/shared/ui/button";

interface Props { onNext: () => void }

export function WelcomeStep({ onNext }: Props): JSX.Element {
  return (
    <div className="flex min-h-[70vh] flex-col items-start justify-center gap-10" data-testid="welcome-step">
      <div className="max-w-3xl space-y-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-[#c7a25a]">
          Welcome to Marketing OS
        </p>
        <h1
          className="font-serif text-[44px] leading-[1.05] tracking-tight text-[#f5efe6] md:text-[64px] md:leading-[1.02]"
          style={{ fontFamily: "'Fraunces', 'Iowan Old Style', Georgia, serif" }}
        >
          Let's build your{" "}
          <span className="italic text-[#c7a25a]">AI marketing department</span>.
        </h1>
        <div className="max-w-xl space-y-4 text-[15px] leading-relaxed text-[#f5efe6]/80 md:text-[17px]">
          <p>
            Everything you're about to explore is fully interactive.
            A complete marketing department has already been prepared for you.
          </p>
          <p>
            Take a look around. When you're ready, we'll make it yours.
          </p>
        </div>
      </div>

      <Button
        onClick={onNext}
        data-testid="welcome-get-started"
        className="group h-14 rounded-full bg-[#c7a25a] px-9 text-[15px] font-medium tracking-wide text-[#0d1310] shadow-[0_20px_60px_-20px_rgba(199,162,90,0.6)] transition-all hover:bg-[#d4b06e] hover:shadow-[0_28px_80px_-20px_rgba(199,162,90,0.7)]"
      >
        Get started
        <span aria-hidden className="ml-2 inline-block transition-transform group-hover:translate-x-1">→</span>
      </Button>

      <p className="max-w-sm text-[12px] leading-relaxed text-[#f5efe6]/40">
        No credit card. No commitment. Nothing enters your workspace without your say-so.
      </p>
    </div>
  );
}
